import { Box, Menu, MenuItem } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';
import Fade from '@mui/material/Fade';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import styled from 'styled-components';

import { GET_CURRENT_VERSION_DATA } from '../../apis/version';
import ArchiveProjectDialog from '../ArchiveProject/ArchiveProjectDialog';
import Button from '../atoms/button';
import ModalEditProject from '../EditProject/index';
import ProjectContext from '../../context/ProjectContext';
import ProjectWarningContext from '../../context/ProjectWarningContext';
import UnshareProject from '../UnshareProject';
import useLoader from '../../context/LoaderContext';
import useProjectVersionHistory from '../../context/VersionHistoryContext';
import VersionHistoryDrawer from '../VersionHistorySidebar';

const CustomItem = styled(MenuItem)`
  &.MuiMenuItem-root {
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 24px;
    &.Mui-selected {
      background-color: transparent;
    }
  }
`;

const options = ['Edit Project', 'Archive Project', 'Manage Users', 'See Version History'];

const IconMenu = () => {
  // init
  const params = useParams();
  const { isLoading, setIsLoading } = useLoader();
  const { projectId } = useContext(ProjectContext);
  const { showVersionHistoryBar, readOnlyMode, selectedListItem, setShowVersionHistoryBar, setSelectedListItem, setReadOnlyMode, setIsCurrentVersion } = useProjectVersionHistory();
  const { dispatch: dispatchRiskBar } = useContext(ProjectWarningContext);

  // states
  const [anchor, setAnchor] = useState(null);
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(-1);
  const [archiveopen, setArchiveOpen] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // constants
  const isHidden = showVersionHistoryBar && readOnlyMode && selectedListItem !== null && selectedListItem !== undefined;

  // mutations/queries
  const [getCurrentVersionData] = useLazyQuery(GET_CURRENT_VERSION_DATA, { fetchPolicy: 'network-only', variables: { input: { projectId: parseInt(projectId, 10), showVersion: false } } });

  const handleDrawerOpen = async () => {
    setShowVersionHistoryBar(true);
    await dispatchRiskBar({
      type: 'SHOW_RISK_BAR',
      payload: {
        showRiskBar: false,
      },
    });
    setDrawerOpen(true);
  };

  const handleDrawerClose = async () => {
    setShowVersionHistoryBar(false);
    if (selectedListItem) {
      if (!isLoading) setIsLoading(true);
      await getCurrentVersionData({ variables: { input: { projectId: parseInt(projectId, 10), showVersion: false } } });
    }
    setReadOnlyMode(false);
    setIsCurrentVersion(true);
    if (selectedListItem) setSelectedListItem(null);
  };

  useEffect(() => {
    if (!showVersionHistoryBar) {
      setDrawerOpen(false);
    }
  }, [showVersionHistoryBar]);

  const openMenu = (event) => {
    setAnchor(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const closeMenu = () => {
    setAnchor(null);
  };

  const handleArchiveClose = () => {
    setArchiveOpen(false);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const onMenuItemClick = (event, index) => {
    setAnchor(null);
    setSelected(index);
    if (index === 0) {
      setOpen(true);
    }
    if (index === 1) {
      setArchiveOpen(true);
    }
    if (index === 2) {
      setOpenDialog(true);
    }
    if (index === 3) {
      handleDrawerOpen();
    }
  };

  return (
    <>
      <Box>
        <Button
          primary
          outlinedColor
          icon
          style={{ display: isHidden ? 'none' : '' }}
          onClick={openMenu}
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
        >
          <MoreHorizIcon sx={{ width: 24, height: 24 }} fontSize="small" />
        </Button>

        <Menu
          className="three-dots-dropdown"
          open={Boolean(anchor)}
          anchorEl={anchor}
          onClose={closeMenu}
          id="fade-menu"
          MenuListProps={{
            'aria-labelledby': 'fade-button',
          }}
          TransitionComponent={Fade}
          keepMounted
          transformOrigin={{ horizontal: 'right', vertical: 'top' }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          style={{
            marginTop: '8px',
          }}
        >
          {options.map((option, index) => (
            <CustomItem
              style={{ width: '180px' }}
              key={`${option}-${index}`}
              onClick={(event) => onMenuItemClick(event, index)}
              selected={index === selected}
            >
              {option}
            </CustomItem>
          ))}
        </Menu>
      </Box>
      {open && (
        <ModalEditProject openToggle={open} handleClose={handleClose} projectId={params.id} />
      )}
      {archiveopen && (
        <ArchiveProjectDialog openToggle={archiveopen} handleArchiveClose={handleArchiveClose} />
      )}
      {openDialog && (
        <UnshareProject openToggle={openDialog} handleCloseDialog={handleCloseDialog} />
      )}
      {drawerOpen && <VersionHistoryDrawer open={drawerOpen} onClose={handleDrawerClose} />}
    </>
  );
};

export default IconMenu;
